document.addEventListener("DOMContentLoaded", function () {
  const accItems = document.querySelectorAll(".block__service-faqs-acc");

  accItems.forEach((item) => {
    const answer = item.querySelector(".block__service-faqs-acc-content");

    // Initialize
    answer.style.maxHeight = "0px";
    answer.style.overflow = "hidden";
    answer.style.transition = "max-height 0.4s ease";

    item.addEventListener("click", function () {
      accItems.forEach((otherItem) => {
        const otherAnswer = otherItem.querySelector(".block__service-faqs-acc-content");
        if (otherItem !== item) {
          otherAnswer.style.maxHeight = "0px";
          otherItem.classList.remove("active");
        }
      });

      const isOpen = item.classList.contains("active");

      if (!isOpen) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        item.classList.add("active");
      } else {
        answer.style.maxHeight = "0px";
        item.classList.remove("active");
      }
    });
  });
});
